import { Card } from 'antd';
import React from 'react';
import verified from '../../../assets/verified.png';

const ExternalBFileThanks = () => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
            background:'white'
        }}>
            <Card
                style={{
                    width: '80vw',  // Width as a percentage of viewport width
                    height: '50vh', // Height as a percentage of viewport height
                    maxWidth: '600px', // Max width for larger screens
                    maxHeight: '400px', // Max height for larger screens
                    background: 'white',
                    boxShadow: '0px 0px 32px 5px rgba(185.20, 177.87, 174.21, 0.30)',
                    borderRadius: 30,
                    border: '1px rgba(185.20, 177.87, 174.21, 0.30) solid',
                    textAlign: "center",
                }}
                bodyStyle={{ padding: "20px" }}
            >
                <img src={verified} height='70px' style={{ marginBottom: '10px', marginTop: '50px' }} />
                <p style={{ color: 'black', margin: 0 }}>Thank you for your time, we have received your details!</p>
                <p style={{ color: 'black', margin: 0 }}>Our team will soon get in touch with you to discuss the results.</p>
                <p style={{ color: 'black', margin: 0 }}>You can now close this window.</p>
            </Card>
        </div>
    );
};

export default ExternalBFileThanks;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/ExternalBFileThanks.js